module.exports = __webpack_public_path__ + "img/house_of_shadows_small.ab4eb424.png";